/**
 * Runs an action in production, or shows a dev-only alert instead.
 *
 * Wrap side-effecting handlers (form submits, navigation, etc.) with this in
 * screen manager hooks so that clicking buttons in local dev doesn't actually
 * call Auth0 — you get an alert describing what would have run. In production
 * (and any non-development NODE_ENV) the wrapped action executes normally and
 * its return value is passed through.
 */
export const executeSafely = async <R>(
  actionDescription: string,
  actionFn: () => R | Promise<R>,
): Promise<R | void> => {
  if (process.env.NODE_ENV === "development") {
    alert(`[DEV ONLY] ${actionDescription}`);
    return;
  }

  return await actionFn();
};
